/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-11 16:22:19
 * @LastEditors: changfeng
 * @LastEditTime: 2023-05-08 10:36:51
 */

import cookie from 'react-cookies';

// 查询cookie
export function getCookie(cookieName: string): string {
  return cookie.load(cookieName);
}

// 从storage中查询token
export function getAccessToken(): string | null {
  return localStorage.getItem('Authorization');
}


// 删除cookie中的token

export function removeAccessToken(): void{
    cookie.remove("JSESSIONID",{path:"/"})
}
